var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 12,
    transform: "rotate(90 19 19)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3312 18.3345L12.6896 18.3304L12.6896 18.3304L12.6851 18.3305C12.2806 18.3375 11.9559 18.6622 11.9489 19.0667L11.9488 19.0667L11.9489 19.0753C11.9558 19.4775 12.2838 19.8115 12.6894 19.8115C12.6894 19.8115 12.6894 19.8115 12.6894 19.8115L18.3266 19.8111L18.3306 25.4524C18.3306 25.4525 18.3306 25.4526 18.3306 25.4527C18.3303 25.8583 18.6649 26.1863 19.0668 26.1932L19.0668 26.1933L19.0754 26.1932C19.4799 26.1862 19.8046 25.8615 19.8116 25.457L19.8117 25.457L19.8117 25.4525L19.8076 19.8109L25.4539 19.8102L18.3312 18.3345ZM18.3312 18.3345L18.3319 12.6879C18.332 12.2849 18.6645 11.9519 19.0678 11.9523L19.0676 12.2023L19.0675 11.9523C19.4767 11.9523 19.8142 12.2823 19.808 12.6949L19.8076 18.3301L25.4474 18.3341C25.86 18.3283 26.1898 18.6653 26.1898 19.0746C26.1897 19.4776 25.8574 19.8104 25.4542 19.8102L18.3312 18.3345Z",
    fill: "#00648C",
    stroke: "#00648C",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.1b54a86279b134e5071bf088238bb4da.svg";
export { ForwardRef as ReactComponent };